import React, { Component } from 'react';
import { formatDate } from './shared/formatters';
import AuthService from '../AuthService';
import constants from '../../config';

var Auth = new AuthService();

class AdminReportedUsers extends Component {
  constructor(props) {
    super(props);
    this.state = { reportedUsers: [], expandedUserId: null, loading: true };
    this.fetchReported = this.fetchReported.bind(this);
  }

  componentDidMount() {
    this.fetchReported();
  }

  componentDidUpdate(prevProps) {
    if (this.props.refreshKey !== prevProps.refreshKey) {
      this.fetchReported();
    }
  }

  fetchReported() {
    var self = this;
    self.setState({ loading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/reported-users')
      .then(function(data) { self.setState({ reportedUsers: data.users || [], loading: false }); })
      .catch(function(err) { console.log('Failed to fetch reported users:', err); self.setState({ loading: false }); });
  }

  render() {
    var self = this;
    var users = this.state.reportedUsers;
    var isDark = document.documentElement.classList.contains('tw-dark');

    if (this.state.loading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
          <div className="tw-text-center">
            <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
            <span className="tw-text-sm tw-text-[#999]">Loading...</span>
          </div>
        </div>
      );
    }

    if (users.length === 0) {
      return (
        <div className="tw-rounded-xl tw-p-12 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          <div className="tw-w-16 tw-h-16 tw-rounded-full tw-mx-auto tw-mb-4 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#064e3b' : '#ECFDF5' }}>
            <i className="fa fa-check tw-text-2xl" style={{ color: '#10B981' }} />
          </div>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">No Reported Users</h3>
          <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-1">All clear — no users have been reported</p>
        </div>
      );
    }

    return (
      <div className="tw-space-y-3">
        <div className="tw-px-1 tw-mb-2">
          <span className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white">{users.length} reported user{users.length !== 1 ? 's' : ''}</span>
        </div>
        {users.map(function(user) {
          var reports = user.userReportsReceived || [];
          var isExpanded = self.state.expandedUserId === user._id;
          var statusColor = user.status === 'active' ? '#10B981' : user.status === 'suspended' ? '#F59E0B' : user.status === 'banned' ? '#EF4444' : '#6B7280';
          var statusBg = user.status === 'active' ? '#ECFDF5' : user.status === 'suspended' ? '#FEF3C7' : user.status === 'banned' ? '#FEE2E2' : '#F3F4F6';

          return (
            <div key={user._id} className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
              <div className="tw-p-4">
                <div className="tw-flex tw-gap-4">
                  {user.profilePic ? (
                    <img src={user.profilePic} alt="" className="tw-w-12 tw-h-12 tw-object-cover tw-rounded-full tw-flex-shrink-0" />
                  ) : (
                    <div className="tw-w-12 tw-h-12 tw-rounded-full tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#f0f0f0' }}>
                      <i className="fa fa-user tw-text-[#ccc]" />
                    </div>
                  )}
                  <div className="tw-flex-1 tw-min-w-0">
                    <div className="tw-flex tw-items-start tw-justify-between tw-gap-2">
                      <div>
                        <span
                          className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-cursor-pointer hover:tw-underline"
                          style={{ color: '#D4A843' }}
                          onClick={function(e) { e.stopPropagation(); self.props.onOpenUserModal(user._id); }}
                        >
                          {user.userName || 'Unknown'}
                        </span>
                        <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-0.5">
                          {user.email || ''}
                          <span className="tw-ml-2 tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium" style={{ backgroundColor: statusBg, color: statusColor }}>
                            {user.status || 'active'}
                          </span>
                          {user.strikes && user.strikes.length > 0 && (
                            <span className="tw-ml-1 tw-text-xs tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium" style={{ backgroundColor: '#FEE2E2', color: '#991B1B' }}>
                              {user.strikes.length} strike{user.strikes.length !== 1 ? 's' : ''}
                            </span>
                          )}
                        </p>
                        {reports.length > 0 && (
                          <p className="tw-text-xs tw-m-0 tw-mt-1">
                            <span style={{ color: '#EF4444', fontWeight: 600 }}>Reported by: </span>
                            {reports.map(function(report, i) {
                              var reporter = report.user || {};
                              return (
                                <span key={i}>
                                  {i > 0 && ', '}
                                  {reporter._id ? (
                                    <span className="tw-cursor-pointer hover:tw-underline" style={{ color: '#D4A843', fontWeight: 500 }} onClick={function(e) { e.stopPropagation(); self.props.onOpenUserModal(reporter._id); }}>{reporter.userName || 'Unknown'}</span>
                                  ) : (reporter.userName || 'Unknown')}
                                </span>
                              );
                            })}
                          </p>
                        )}
                      </div>
                      <span className="tw-text-xs tw-px-2.5 tw-py-1 tw-rounded-full tw-font-bold tw-flex-shrink-0" style={{ backgroundColor: '#FEE2E2', color: '#991B1B' }}>
                        {user.userReportedCount} report{user.userReportedCount !== 1 ? 's' : ''}
                      </span>
                    </div>
                    <div className="tw-mt-3 tw-flex tw-flex-wrap tw-gap-2">
                      <button
                        className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-font-medium tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#222]"
                        onClick={function() { self.setState({ expandedUserId: isExpanded ? null : user._id }); }}
                      >
                        <i className={'fa ' + (isExpanded ? 'fa-chevron-up' : 'fa-chevron-down') + ' tw-mr-1'} />
                        {reports.length} Report Detail{reports.length !== 1 ? 's' : ''}
                      </button>
                      <button
                        className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-font-medium tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                        style={{ backgroundColor: '#F3F4F6', color: '#374151' }}
                        onClick={function() { self.props.onConfirm({ type: 'dismissUserReports', userId: user._id, userName: user.userName }); }}
                      >
                        <i className="fa fa-times tw-mr-1" />Dismiss Reports
                      </button>
                      <button
                        className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-font-medium tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                        style={{ backgroundColor: '#EFF6FF', color: '#1D4ED8' }}
                        onClick={function() { self.props.onOpenUserModal(user._id); }}
                      >
                        <i className="fa fa-user tw-mr-1" />View User
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {isExpanded && reports.length > 0 && (
                <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-bg-[#fafafa] dark:tw-bg-[#111] tw-px-5 tw-py-4">
                  <h4 className="tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-m-0 tw-mb-3">Report History</h4>
                  <div className="tw-space-y-3">
                    {reports.map(function(report, i) {
                      var reporter = report.user || {};
                      return (
                        <div key={i} className="tw-flex tw-gap-3 tw-pb-3 tw-border-b tw-border-[#eee] dark:tw-border-[#222] last:tw-border-0 last:tw-pb-0">
                          <div className="tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: '#FEE2E2' }}>
                            <i className="fa fa-flag tw-text-xs" style={{ color: '#EF4444' }} />
                          </div>
                          <div className="tw-flex-1 tw-min-w-0">
                            <div className="tw-flex tw-items-center tw-gap-2 tw-mb-0.5">
                              <span className="tw-text-xs tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white">{reporter.userName || 'Unknown'}</span>
                              <span className="tw-text-xs tw-text-[#999]">{report.createdAt ? formatDate(report.createdAt) : ''}</span>
                            </div>
                            <div className="tw-text-xs tw-font-medium tw-text-[#444] dark:tw-text-[#ccc]">{report.reason || 'No reason'}</div>
                            {report.details && <div className="tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-mt-0.5">{report.details}</div>}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default AdminReportedUsers;
